// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"179":"9b29d045","357":"ee158670","523":"9adfa5fa","729":"541b00e1","887":"e4aa8f44","908":"b22650fc","927":"fc9d3aa7","960":"fcac0096"}[chunkId] + ".js";
};